/**
 * Frontend Script
 */

jQuery(document).ready(function($){

    $('.wp-block-custom-blocks-benefits').each(function(){
        const benefits = $(this).find('.benefits');
        const buttonShow = $(this).find('button.show-benefits');

        if (benefits.find('.benefit:hidden').length > 0) {
            buttonShow.show();
        }

        buttonShow.on('click', function(){
            benefits.find('.benefit:hidden').fadeIn(500);
            if (benefits.find('.benefit:hidden').length == 0) {
                buttonShow.hide();
            }
        });
      
    })
});


// WEBPACK FOOTER //
// ./src/blocks/benefits/js/script.js